import React from "react";
import { ErrorMessage, Field } from "formik";
import { Col, Form, Row } from "react-bootstrap";

interface FormFieldProps {
    name: string;
    label: string;
    type: string;
    validate?: (value: string) => void;
    disabled?: boolean;
}

export const InvitationAcceptanceFormField: React.FC<FormFieldProps> = ({
    name,
    label,
    type,
    validate,
    disabled = false
}) => {
    return (
        <Form.Group as={Row} className="mb-3" controlId={name}>
            <Form.Label column sm={3}>
                {label}
            </Form.Label>
            <Col sm={9}>
                <Field
                    name={name}
                    type={type}
                    validate={validate}
                    disabled={disabled}
                    className="form-control"
                />
                <ErrorMessage
                    name={name}
                    component="div"
                    className="invalid-feedback"
                />
            </Col>
        </Form.Group>
    );
};
